import { createNode, ZonedDateTimeDataType, InstantDataType } from '@glueapp/graph-types';
import { toZonedDateTime, fromInstant } from '../../utils/temporal';

export const ZonedDateTimeToInstant = createNode({
    id: 'ZonedDateTime to Instant',
    name: 'ZonedDateTime to Instant',
    description: 'Converts a ZonedDateTime to an Instant (epoch milliseconds)',
    aiDescription:
        'Takes a ZonedDateTime on the "ZonedDateTime" port and outputs the corresponding Instant on the "Instant" port, representing the exact moment in time.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        ZonedDateTime: ZonedDateTimeDataType,
    },
    outPorts: {
        Instant: InstantDataType,
    },
    execute: function (input) {
        const zdt = toZonedDateTime(input.inPorts.ZonedDateTime);
        return { output: { Instant: fromInstant(zdt.toInstant()) } };
    },
});
